<div class="mainContainer mt-5 d-flex flex-column align-items-center">
  <div class="vMax wrap">
    <div class="heroWrap">
      <h2 class="headingWL">Privacy <span>Policy</span></h2>
    </div>
    <div class="wrapper">
      <div class="cardWrap">
        <p class="vtext1">
          We value your trust. In order to honour that trust, VIRSA adheres to ethical standards in collecting, using,
          and safeguarding any information you provide. <br /><br />
          <b>Virsa The Digital Learning Private Limited,</b> operating under the brand name VIRSA, is a leading EdTech
          and educational technology solutions company incorporated in India. We provide products and services including
          <b>Interactive Flat Panels, Panel Safety Shutters, All-in-One PCs, Learning Management Systems (LMS), and
            Digital
            K-12 educational content.</b><br /><br />
          This Privacy Policy governs your use of our website <a
            href="https://www.virsaindia.in">https://www.virsaindia.in</a>
          (“Website”), and all associated products, solutions, services, and digital platforms operated by the
          Company.<br /><br />
          Please read this Privacy Policy (“Policy”) carefully before accessing or using our Website, products, or
          services, along with the applicable Terms of Use (“ToU”). By accessing or using our Website or Services, you
          agree to be legally bound by this Policy. If you do not agree, please do not use our Website or Services.
        </p>
      </div>

      <div class="cardWrap">
        <h4 class="headingBS">User Provided <span>Information</span></h4>
        <p class="vtext1">We may collect information that you voluntarily provide to us when you:</p>
        <ul class="vtext1" style="list-style-type: disc; margin-left: 20px;">
          <li>Visit or interact with our Website</li>
          <li>Enquire about our products or services</li>
          <li>Request a demo, quotation, or support</li>
          <li>Register for LMS or Digital K-12 solutions</li>
          <li>Communicate with us via forms, email, phone, or other channels</li>
        </ul>
        <br>
        <p class="vtext1">This information may include:</p>
        <ul class="vtext1" style="list-style-type: disc; margin-left: 20px;">
          <li>Name, designation, organization name</li>
          <li>Email address, phone number, city/state</li>
          <li>Business or institutional requirements</li>
          <li>Login credentials (where applicable for LMS access)</li>
          <li>Any other information shared while communicating with us</li>
        </ul>
        <br>
        <p class="vtext1">
          The information collected may be categorized as <b>Personal Information</b>, <b>Sensitive Personal
            Information</b>, or
          <b>Associated Information</b>, as defined under the Information Technology (Reasonable Security Practices and
          Procedures and Sensitive Personal Data or Information) Rules, 2011.
        </p>
        <p class="vtext1">We use this information to:</p>
        <ul class="vtext1" style="list-style-type: disc; margin-left: 20px;">
          <li>Provide product information and services</li>
          <li>Respond to enquiries and support requests</li>
          <li>Share proposals, quotations, and updates</li>
          <li>Send important service-related or marketing communications</li>
        </ul>
        <p class="vtext1">
          You may choose not to provide certain information or withdraw consent by contacting us in writing. However,
          this may limit our ability to provide certain services or support.
        </p>
      </div>

      <div class="cardWrap">
        <h4 class="headingBS">Automatically Collected <span>Information</span></h4>
        <p class="vtext1">When you visit our Website or use our digital services, we may automatically collect certain
          information, including:</p>
        <ul class="vtext1" style="list-style-type: disc; margin-left: 20px;">
          <li>IP address</li>
          <li>Browser type and version</li>
          <li>Operating system</li>
          <li>Device information</li>
          <li>Pages visited and time spent on the Website</li>
        </ul>
        <p class="vtext1">This information is used to understand user behaviour, improve Website performance, and
          enhance user experience.</p>
      </div>

      <div class="cardWrap">
        <h4 class="headingBS">Use of Your Personal <span>Information</span></h4>
        <p class="vtext1">We use the collected information to:</p>
        <ul class="vtext1" style="list-style-type: disc; margin-left: 20px;">
          <li>Deliver and improve our products and services</li>
          <li>Understand customer needs and usage trends</li>
          <li>Provide LMS and Digital K-12 services effectively</li>
          <li>Improve product performance and content quality</li>
          <li>Communicate updates, offers, and service information</li>
        </ul>
        <p class="vtext1">We do not sell, trade, or rent your personal information to third parties, except:</p>
        <ul class="vtext1" style="list-style-type: disc; margin-left: 20px;">
          <li>When required by law or legal process</li>
          <li>To trusted service providers working on our behalf under confidentiality obligations</li>
          <li>With your explicit consent</li>
        </ul>
        <p class="vtext1">Aggregated and anonymized data may be shared for research, analytics, or business improvement
          purposes.</p>
      </div>

      <div class="cardWrap">
        <h4 class="headingBS">Access to Your Personal <span>Information</span></h4>
        <p class="vtext1">Where applicable, users may request access to or correction of their personal information. We
          take reasonable steps to ensure that personal data is accurate, complete, and up to date.</p>
      </div>

      <div class="cardWrap">
        <h4 class="headingBS">Cookies</h4>
        <p class="vtext1">Our Website may use cookies to:</p>
        <ul class="vtext1" style="list-style-type: disc; margin-left: 20px;">
          <li>Enhance user experience</li>
          <li>Remember user preferences</li>
          <li>Analyze Website traffic and performance</li>
        </ul>
        <p class="vtext1">You may choose to disable cookies through your browser settings. However, some features of the
          Website may not function properly.</p>
      </div>

      <div class="cardWrap">
        <h4 class="headingBS">Links to Other <span>Websites</span></h4>
        <p class="vtext1">Our Website may contain links to third-party websites. We are not responsible for the privacy
          practices or content of such external websites. Users are encouraged to review the privacy policies of those
          websites independently.</p>
      </div>

      <div class="cardWrap">
        <h4 class="headingBS">Alerts and <span>Communications</span></h4>
        <p class="vtext1">We may contact you via email, phone call, SMS, or other communication channels to:</p>
        <ul class="vtext1" style="list-style-type: disc; margin-left: 20px;">
          <li>Respond to enquiries</li>
          <li>Share product updates or service information</li>
          <li>Inform you about offers, events, or important notices</li>
        </ul>
        <p class="vtext1">You may opt out of marketing communications at any time.</p>
      </div>

      <div class="cardWrap">
        <h4 class="headingBS">Public <span>Forums</span></h4>
        <p class="vtext1">If our Website or digital platforms include discussion areas or public forums, any information
          shared there may become publicly accessible. Users are advised to avoid sharing sensitive personal information
          in such spaces.</p>
      </div>

      <div class="cardWrap">
        <h4 class="headingBS">Security</h4>
        <p class="vtext1">We implement reasonable physical, technical, and administrative security measures to protect
          your information against unauthorized access, alteration, disclosure, or destruction. However, no data
          transmission or storage system can be guaranteed to be completely secure.</p>
      </div>

      <div class="cardWrap">
        <h4 class="headingBS">Data <span>Retention</span></h4>
        <p class="vtext1">We retain personal information only for as long as necessary:</p>
        <ul class="vtext1" style="list-style-type: disc; margin-left: 20px;">
          <li>To fulfil the purposes for which it was collected</li>
          <li>To comply with legal, regulatory, or contractual obligations</li>
        </ul>
        <p class="vtext1">Typically, data may be retained while a business relationship exists and for a reasonable
          period thereafter, unless a longer retention period is required by law.</p>
      </div>

      <div class="cardWrap">
        <h4 class="headingBS">Log <span>Information</span></h4>
        <p class="vtext1">Our servers may automatically record information such as:</p>
        <ul class="vtext1" style="list-style-type: disc; margin-left: 20px;">
          <li>IP address</li>
          <li>Browser type</li>
          <li>Date and time of Website access</li>
          <li>Referring URLs</li>
        </ul>
        <p class="vtext1">This information is used for system administration, security, and analytics.</p>
      </div>

      <div class="cardWrap">
        <h4 class="headingBS">User <span>Communications</span></h4>
        <p class="vtext1">Any communications sent to us (emails, messages, calls, or enquiry forms) may be retained to:
        </p>
        <ul class="vtext1" style="list-style-type: disc; margin-left: 20px;">
          <li>Process your requests</li>
          <li>Respond to queries</li>
          <li>Improve our products and services</li>
        </ul>
      </div>

      <div class="cardWrap">
        <h4 class="headingBS">Changes to This Privacy <span>Policy</span></h4>
        <p class="vtext1">We may update this Privacy Policy from time to time to reflect changes in our practices,
          products, or legal requirements. Continued use of the Website or Services after changes are posted constitutes
          acceptance of the updated Policy.</p>
      </div>

      <div class="cardWrap">
        <h4 class="headingBS">Your <span>Consent</span></h4>
        <p class="vtext1">By accessing our Website or using our products and services, you consent to the collection,
          use, processing, and storage of your information as described in this Policy. All data is processed and stored
          in India in accordance with applicable Indian laws.</p>
      </div>

      <div class="cardWrap">
        <h4 class="headingBS">Contact <span>Information</span></h4>
        <p class="vtext1">For any questions, concerns, or grievances regarding this Privacy Policy, please contact:<br>
          Grievance Officer:<br></p>
        <ul class="vtext1" style="list-style-type: disc; margin-left: 20px;">
          <li>Email: <a href="mailto:info@virsaindia.in" style="font-weight: bold; color: black;">info@virsaindia.in</a>
          </li>
          <li>Website: <a href="https://www.virsaindia.in" target="_blank"
              style="font-weight: bold; color: black;">https://www.virsaindia.in</a></li>
        </ul>
      </div>
    </div>
  </div>
</div>